// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.character-selection-container {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: var(--jedi-background);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: clamp(6px, 1.4vh, 10px);
  color: white;
  z-index: 9999;
  font-family: 'Arial', sans-serif;
  overflow-y: hidden;
  overflow-x: hidden;
  box-sizing: border-box;
  touch-action: pan-y;
}

.character-selection-content {
  width: min(100%, 1040px);
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(8px, 1.4vh, 14px);
  padding-top: clamp(4px, 0.8vh, 8px);
  padding-bottom: calc(78px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.character-selection-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(4px, 1vh, 8px);
  flex-shrink: 0;
}

.character-selection-main {
  width: 100%;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(10px, 1.6vh, 16px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 4px 8px;
  overscroll-behavior: contain;
  box-sizing: border-box;
}

.character-selection-help-button {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 10001;
  border: 1px solid rgba(196, 222, 29, 0.6);
  background: rgba(0, 0, 0, 0.55);
  color: var(--jedi-green);
  border-radius: 50%;
  width: 38px;
  height: 38px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, transform 0.2s;
}

.character-selection-help-button:hover {
  background: rgba(0, 0, 0, 0.75);
  transform: scale(1.1);
}

.character-selection-logout-button {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10001;
  border: 1px solid rgba(196, 222, 29, 0.6);
  background: rgba(0, 0, 0, 0.55);
  color: var(--jedi-green);
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: 700;
  cursor: pointer;
}

/* === Help overlay & card === */
.help-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10010;
}

.help-card {
  position: relative;
  background: rgba(10, 10, 30, 0.92);
  border: 1px solid rgba(196, 222, 29, 0.35);
  border-radius: 16px;
  width: min(900px, 92vw);
  max-height: 90vh;
  max-height: 90dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  animation: helpFadeIn 0.25s ease-out;
  overflow-y: auto;
}

@keyframes helpFadeIn {
  from { opacity: 0; transform: scale(0.95) translateY(10px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.help-card-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  cursor: pointer;
  z-index: 1;
}

.help-card-close:hover {
  color: #fff;
}

.help-card-title {
  margin: 0;
  padding: 18px 20px 10px;
  font-size: 1.5rem;
  color: var(--jedi-green, #c4de1d);
  text-align: center;
  flex-shrink: 0;
}

.help-card-body {
  padding: 4px 20px 20px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.help-section {
  margin-bottom: 14px;
}

.help-section-title {
  margin: 0 0 4px;
  font-size: 1.3rem;
  color: #fff;
}

.help-section-text {
  margin: 0 0 6px;
  font-size: 1.25rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.82);
}

.help-tts-link {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--jedi-green, #c4de1d);
  font-size: 1.2rem;
  line-height: 1.45;
  text-decoration: underline;
  cursor: pointer;
}

.help-tts-link:hover {
  color: #e2f06a;
}

.help-tts-overlay {
  z-index: 10011;
}

.help-tts-card {
  width: min(960px, 96vw);
  height: min(90vh, 90dvh);
  max-height: min(90vh, 90dvh);
  padding: 0;
  overflow: hidden;
}

.help-tts-iframe {
  flex: 1 1;
  width: 100%;
  min-height: 0;
  border: none;
}

.help-tts-footer {
  padding: 16px 20px 20px;
  display: flex;
  justify-content: center;
  background: rgba(10, 10, 30, 0.98);
}

.help-tts-back-button {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid rgba(196, 222, 29, 0.45);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(196, 222, 29, 0.22), rgba(196, 222, 29, 0.12));
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}

.help-tts-back-button:hover {
  background: linear-gradient(180deg, rgba(196, 222, 29, 0.3), rgba(196, 222, 29, 0.18));
}

.title {
  font-size: clamp(1.35rem, 2vw + 0.7rem, 2.5rem);
  margin: 0;
  line-height: 1.1;
  text-align: center;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.9);
  color: var(--jedi-main-title);
}

.instructions {
  font-size: clamp(0.85rem, 0.7vw + 0.75rem, 1.2rem);
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);
  margin: 0;
  text-align: center;
  color: var(--jedi-main-title);
  line-height: 1.25;
  max-width: min(90%, 720px);
}

.characters-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(8px, 2vw, 20px);
  margin-bottom: 0;
  width: min(100%, 820px);
  max-width: 820px;
}

.character-item {
  width: clamp(70px, 11vw, 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: clamp(6px, 1vh, 10px) clamp(5px, 0.8vw, 10px);
  min-height: clamp(90px, 14vw, 118px);
  cursor: grab;
  transition: transform 0.2s, box-shadow 0.2s;
  touch-action: none;
  box-sizing: border-box;
}

.character-item:hover {
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.character-item.selected {
  opacity: 0.5;
  cursor: not-allowed;
}

.character-item.dragging {
  opacity: 0.3;
  transform: scale(0.95);
  pointer-events: none;
}

.character-item:active {
  transform: scale(0.95);
}

.character-image {
  width: clamp(50px, 8vw, 80px);
  height: clamp(50px, 8vw, 80px);
  object-fit: contain;
  margin-bottom: clamp(6px, 1vh, 10px);
}

.character-name {
  font-size: clamp(0.72rem, 0.45vw + 0.65rem, 0.9rem);
  text-align: center;
  color: var(--jedi-main-title);
  line-height: 1.15;
}

.userInfo-container {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: clamp(10px, 1.5vw, 16px);
  width: min(100%, 980px);
  flex-wrap: wrap;
}

.board-drop-area {
  width: auto;
  max-width: none;
  flex: 1 1 420px;
  min-height: clamp(88px, 14vh, 140px);
  background-color: rgba(0, 0, 0, 0.3);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: clamp(10px, 1.8vh, 20px);
  margin-bottom: 0;
  transition: background-color 0.3s;
  box-sizing: border-box;
}

.board-drop-area:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.board-drop-area.touch-drag-active {
  background-color: rgba(76, 175, 80, 0.2);
  border-color: rgba(76, 175, 80, 0.6);
  box-shadow: 0 0 20px rgba(76, 175, 80, 0.3);
}

.selected-characters {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: min(24vh, 220px);
  overflow-y: auto;
  padding-right: 4px;
  box-sizing: border-box;
}

.board-drop-area p {
  margin: 0 0 8px;
  font-size: clamp(0.82rem, 0.35vw + 0.72rem, 1rem);
  text-align: center;
}

.userInfo-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}

.userInfo-item {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.autoavaliacao, .userInfo {
  padding: 12px 16px;
  background-color: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;

  position: relative !important;
  height: max-content !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  box-sizing: border-box;
}

.userInfo {
  flex: 0 1 280px;
  width: min(100%, 300px);
  max-width: 320px;
  max-height: fit-content !important;
  align-self: stretch;
}

.autoavaliacao {
  width: min(100%, 980px);
}

.autoavaliacao-title, .userInfo-title {
  margin: 0 0 10px;
  font-size: clamp(0.85rem, 0.35vw + 0.78rem, 0.95rem);
  color: var(--jedi-main-title);
  text-align: center;
}

.autoavaliacao-options {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.autoavaliacao-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: clamp(5px, 0.7vh, 6px) clamp(8px, 1vw, 10px);
  border-radius: 999px;
  cursor: pointer;
  border: 1px solid transparent;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.06);
  font-size: clamp(0.78rem, 0.3vw + 0.72rem, 0.9rem);
}

.autoavaliacao-option.selected {
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(76, 175, 80, 0.2);
}

.autoavaliacao-option input[type="radio"] {
  accent-color: #4CAF50;
}

.selected-character {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  gap: clamp(8px, 1vw, 12px);
  padding: clamp(8px, 1.2vh, 10px);
  animation: fadeIn 0.3s ease-in;
}

.selected-character-image {
  width: clamp(35px, 6vw, 50px);
  height: clamp(35px, 6vw, 50px);
  object-fit: contain;
  margin-right: 0;
}

.selected-character-info {
  flex: 1 1;
}

.selected-character-name {
  font-size: clamp(0.9rem, 0.5vw + 0.8rem, 1.1rem);
  font-weight: bold;
  margin-bottom: 5px;
}

.player-number {
  font-size: clamp(0.75rem, 0.35vw + 0.68rem, 0.9rem);
  color: #FFEB3B;
}

.remove-character {
  background-color: rgba(255, 0, 0, 0.3);
  border: none;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.remove-character:hover {
  background-color: rgba(255, 0, 0, 0.5);
}

.actions {
  display: flex;
  justify-content: center;
  width: min(100%, 980px);
  flex-shrink: 0;
}

.preferences-trigger {
  position: fixed;
  left: 50%;
  bottom: calc(10px + env(safe-area-inset-bottom));
  z-index: 10005;
  background: var(--jedi-pink);
  border: none;
  border-radius: 999px;
  color: #fff;
  padding: 5px 15px;
  font-weight: bold;
  font-size: 0.8rem;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: transform 0.2s ease, opacity 0.2s ease;
  transform: translateX(-50%);
  white-space: nowrap;
}

.preferences-trigger:hover {
  transform: translate(-50%, -2px);
}

.bottom-sheet {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  max-height: 90vh;
  max-height: 90dvh;
  transform: translateY(100%);
  display: flex;
  justify-content: center;
  pointer-events: none;
  transition: transform 0.35s cubic-bezier(0.2, 1, 0.3, 1);
  z-index: 10004;
}

.bottom-sheet--open {
  transform: translateY(0);
  pointer-events: auto;
}

.bottom-sheet__overlay {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(2px);
}

.bottom-sheet__panel {
  position: relative;
  width: min(960px, 100%);
  padding: 0 20px calc(30px + env(safe-area-inset-bottom));
  pointer-events: auto;
  box-sizing: border-box;
}

.bottom-sheet__handle {
  background: #ED62FF;
  border-radius: 24px 24px 0 0;
  padding: 12px 16px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: grab;
  font-weight: bold;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);
  letter-spacing: 0.05em;
}

.bottom-sheet__handle:active {
  cursor: grabbing;
}

.bottom-sheet__chevron {
  font-size: 1.2rem;
}

.game-preferences-panel {
  width: 100%;
  max-height: calc(90vh - 72px);
  max-height: calc(90dvh - 72px);
  overflow-y: auto;
  padding: 20px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.55);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: #fff;
}

.game-preferences-panel h3 {
  margin: 0;
  font-size: 1.4rem;
  color: var(--jedi-main-title);
  text-align: center;
}

.preference-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preference-header {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  color: #fefefe;
}

.preference-helper {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
}

.game-preferences-panel input[type="range"] {
  width: 100%;
}

.game-preferences-panel select {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
}

.start-game-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 30px;
  width: min(100%, 560px);
  min-height: clamp(40px, 6vh, 52px);
  padding: clamp(10px, 1.4vh, 12px) clamp(20px, 3vw, 30px);
  font-size: clamp(0.95rem, 0.6vw + 0.85rem, 1.2rem);
  font-weight: bold;
  text-shadow: 3px 3px 7px rgba(0, 0, 0, 0.9);
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  line-height: 1.15;
}

.start-game-button:hover:not(:disabled) {
  background-color: #45a049;
  transform: scale(1.05);
}

.start-game-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para o feedback visual de arrastar no touch */
.touch-drag-image {
  pointer-events: none;
  z-index: 10000;
}

.dragging-preview {
  background-color: rgba(255, 255, 255, 0.9);
  border: 2px solid var(--jedi-green);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  transform: rotate(5deg);
}

/* Melhorias para toque */
.character-item {
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}

.board-drop-area {
  touch-action: none;
}

.sprite-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.sprite-loading-card {
  background: rgba(0, 0, 0, 0.85);
  border-radius: 16px;
  padding: 24px;
  width: min(360px, 90vw);
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sprite-loading-progress {
  width: 100%;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.sprite-loading-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50, #8BC34A);
  transition: width 0.2s ease;
}

.sprite-loading-percentage {
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
}

.sprite-loading-list {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #ffffff;
  font-size: 0.95rem;
}

.sprite-loading-list li {
  padding: 4px 0;
}

.sprite-loading-error {
  color: #ff6b6b;
  font-weight: bold;
}

.sprite-loading-actions {
  display: flex;
  justify-content: center;
}

.sprite-loading-close {
  margin-top: 16px;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #ffffff22;
  color: #ffffff;
  cursor: pointer;
}

.sprite-loading-close:hover {
  background: #ffffff33;
}

/* Media queries para diferentes tamanhos de tela */
@media (max-width: 480px) {
  .character-selection-container {
    padding: 5px;
  }

  .character-selection-content {
    gap: 8px;
    padding-bottom: calc(82px + env(safe-area-inset-bottom));
  }

  .character-selection-main {
    padding: 0 2px 6px;
  }

  .game-preferences-panel {
    padding: 15px;
    gap: 15px;
  }
  
  .logo-jedi {
    margin: 5px 0 !important;
    padding: 5px !important;
  }
  
  .logo-jedi img {
    width: 40% !important;
  }
  
  .title {
    font-size: 1.4rem !important;
    margin: 5px 0 !important;
  }
  
  .instructions {
    font-size: 0.85rem !important;
    margin: 5px 0 10px 0 !important;
    padding: 0 15px !important;
  }
  
  .characters-container {
    gap: 8px !important;
    max-width: 100% !important;
  }
  
  .character-item {
    width: 70px !important;
    padding: 8px 5px !important;
    min-height: 90px !important;
  }
  
  .character-image {
    width: 50px !important;
    height: 50px !important;
  }
  
  .character-name {
    font-size: 0.7rem !important;
  }
  
  .userInfo-container {
    flex-direction: column;
    align-items: stretch;
  }

  .board-drop-area {
    width: 100% !important;
    min-height: 88px !important;
    padding: 5px 10px !important;
    flex-basis: auto !important;
  }

  .autoavaliacao,
  .userInfo {
    width: 100% !important;
    padding: 10px !important;
  }

  .userInfo {
    max-width: none !important;
  }

  .autoavaliacao-options {
    gap: 6px;
  }

  .autoavaliacao-option {
    font-size: 0.8rem;
    padding: 5px 8px;
  }

  .game-preferences-panel {
    width: 96%;
  }
  
  .board-drop-area p {
    font-size: 0.85rem !important;
    margin: 0 0 3px 0 !important;
  }
  
  .selected-character {
    padding: 8px !important;
  }
  
  .selected-character-image {
    width: 35px !important;
    height: 35px !important;
  }
  
  .selected-character-name {
    font-size: 0.9rem !important;
  }
  
  .player-number {
    font-size: 0.75rem !important;
  }
  
  .remove-character {
    width: 25px !important;
    height: 25px !important;
    font-size: 0.9rem !important;
  }
  
  .start-game-button {
    width: 100%;
    padding: 10px 20px !important;
    font-size: 0.95rem !important;
    min-height: 40px !important;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .character-selection-container {
    padding: 8px;
  }
  
  .logo-jedi {
    margin: 8px 0 !important;
  }
  
  .logo-jedi img {
    width: 45% !important;
  }
  
  .title {
    font-size: 1.6rem;
    margin: 8px 0;
  }
  
  .instructions {
    font-size: 0.9rem;
    padding: 0 15px;
    text-align: center;
    margin: 8px 0 15px 0;
  }
  
  .characters-container {
    gap: 12px;
    padding: 0 10px;
  }
  
  .character-item {
    width: 80px;
    padding: 12px 8px;
    min-height: 100px;
  }
  
  .character-image {
    width: 60px;
    height: 60px;
  }
  
  .character-name {
    font-size: 0.8rem;
  }
  
  .board-drop-area {
    min-height: 100px;
    padding: 3px 12px;
  }

  .autoavaliacao {
    width: min(100%, 920px);
  }
  
  .board-drop-area p {
    font-size: 0.9rem;
    margin: 0 0 5px 0;
  }
  
  .selected-character {
    padding: 12px;
  }
  
  .selected-character-image {
    width: 40px;
    height: 40px;
  }
  
  .selected-character-name {
    font-size: 1rem;
  }
  
  .player-number {
    font-size: 0.8rem;
  }
  
  .remove-character {
    width: 35px;
    height: 35px;
    font-size: 1.1rem;
  }
  
  .start-game-button {
    padding: 12px 25px;
    font-size: 1rem;
    min-height: 45px;
  }
}

/* Específico para dispositivos com toque */
/* Ajustes para dispositivos muito pequenos */
@media (max-height: 700px) {
  .character-selection-container {
    padding: 5px;
  }

  .character-selection-content {
    gap: 6px;
    padding-bottom: calc(74px + env(safe-area-inset-bottom));
  }

  .character-selection-main {
    gap: 8px;
  }
  
  .logo-jedi {
    margin: 2px 0 !important;
  }

  .logo-jedi img {
    width: min(32%, 150px) !important;
  }
  
  .title {
    font-size: 1.2rem !important;
    margin: 2px 0 !important;
  }
  
  .instructions {
    font-size: 0.8rem !important;
    margin: 2px 0 8px 0 !important;
  }
  
  .characters-container {
    margin-bottom: 10px !important;
  }

  .character-item {
    min-height: 84px !important;
    padding: 6px 5px !important;
  }

  .character-image {
    width: 46px !important;
    height: 46px !important;
    margin-bottom: 4px !important;
  }
  
  .board-drop-area {
    min-height: 60px !important;
    padding: 10px !important;
  }

  .selected-characters {
    max-height: min(18vh, 160px);
  }

  .autoavaliacao,
  .userInfo {
    padding: 8px 10px !important;
  }

  .autoavaliacao-title,
  .userInfo-title {
    margin-bottom: 6px;
  }

  .autoavaliacao-option {
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  .start-game-button {
    min-height: 38px !important;
    font-size: 0.9rem !important;
    padding: 8px 16px !important;
  }

  .preferences-trigger {
    font-size: 0.72rem;
    padding: 5px 12px;
  }
}

@media (max-width: 480px) and (max-height: 700px) {
  .logo-jedi img {
    width: min(34%, 128px) !important;
  }

  .userInfo-container {
    gap: 8px;
  }

  .board-drop-area p {
    font-size: 0.8rem !important;
  }

  .selected-character {
    padding: 6px !important;
  }

  .selected-character-name {
    font-size: 0.82rem !important;
  }

  .player-number {
    font-size: 0.7rem !important;
  }
}

@media (pointer: coarse) {
  .character-item {
    margin: 0;
  }
  
  .character-item:hover {
    /* Remover hover em dispositivos de toque */
    transform: none;
    box-shadow: none;
  }
  
  .character-item:active {
    transform: scale(0.95);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  }
  
  .board-drop-area:hover {
    /* Remover hover em dispositivos de toque */
    background-color: rgba(0, 0, 0, 0.3);
  }
}

/* Estilos para versão do jogo */
.game-version {
  cursor: pointer;
  bottom: calc(10px + env(safe-area-inset-bottom)) !important;
  right: clamp(6px, 2vw, 10px) !important;
  font-size: clamp(0.7rem, 1.5vw, 0.8rem) !important;
}

.version-info {
  margin: 0;
  padding: 0;
}

.build-info {
  display: none;
  margin: 4px 0 4px 0;
  padding: 0;
  font-size: 1.2rem;
  opacity: 0.9;
}

.game-version:hover .build-info {
  display: block;
} 
.game-version:hover .version-info {
  display: none;
} `, "",{"version":3,"sources":["webpack://./src/components/CharacterSelection.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,uFAAuF;EACvF,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,+CAA+C;EAC/C,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,sDAAsD;EACtD,oCAAoC;EACpC,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;;EAEnB,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gDAAgD;EAChD,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;EAClD,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wDAAwD;EACxD,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,wDAAwD;EACxD,kDAAkD;EAClD,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,iDAAiD;EACjD,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C,6CAA6C;AAC7C;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,wDAAwD;EAC1D;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,6CAA6C;EAC/C;;EAEA;IACE,2CAA2C;IAC3C,oCAAoC;EACtC;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,2DAA2D;EAC3D,uCAAuC;EACvC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf","sourcesContent":[".character-selection-container {\r\n  position: fixed;\r\n  inset: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  min-height: 100vh;\r\n  min-height: 100dvh;\r\n  background-color: var(--jedi-background);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  padding: clamp(6px, 1.4vh, 10px);\r\n  color: white;\r\n  z-index: 9999;\r\n  font-family: 'Arial', sans-serif;\r\n  overflow-y: hidden;\r\n  overflow-x: hidden;\r\n  box-sizing: border-box;\r\n  touch-action: pan-y;\r\n}\r\n\r\n.character-selection-content {\r\n  width: min(100%, 1040px);\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: clamp(8px, 1.4vh, 14px);\r\n  padding-top: clamp(4px, 0.8vh, 8px);\r\n  padding-bottom: calc(78px + env(safe-area-inset-bottom));\r\n  box-sizing: border-box;\r\n}\r\n\r\n.character-selection-header {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: clamp(4px, 1vh, 8px);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.character-selection-main {\r\n  width: 100%;\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: clamp(10px, 1.6vh, 16px);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 0 4px 8px;\r\n  overscroll-behavior: contain;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.character-selection-help-button {\r\n  position: absolute;\r\n  top: 14px;\r\n  left: 14px;\r\n  z-index: 10001;\r\n  border: 1px solid rgba(196, 222, 29, 0.6);\r\n  background: rgba(0, 0, 0, 0.55);\r\n  color: var(--jedi-green);\r\n  border-radius: 50%;\r\n  width: 38px;\r\n  height: 38px;\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n\r\n.character-selection-help-button:hover {\r\n  background: rgba(0, 0, 0, 0.75);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.character-selection-logout-button {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 14px;\r\n  z-index: 10001;\r\n  border: 1px solid rgba(196, 222, 29, 0.6);\r\n  background: rgba(0, 0, 0, 0.55);\r\n  color: var(--jedi-green);\r\n  border-radius: 999px;\r\n  padding: 8px 14px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n/* === Help overlay & card === */\r\n.help-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  backdrop-filter: blur(3px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10010;\r\n}\r\n\r\n.help-card {\r\n  position: relative;\r\n  background: rgba(10, 10, 30, 0.92);\r\n  border: 1px solid rgba(196, 222, 29, 0.35);\r\n  border-radius: 16px;\r\n  width: min(900px, 92vw);\r\n  max-height: 90vh;\r\n  max-height: 90dvh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\r\n  animation: helpFadeIn 0.25s ease-out;\r\n  overflow-y: auto;\r\n}\r\n\r\n@keyframes helpFadeIn {\r\n  from { opacity: 0; transform: scale(0.95) translateY(10px); }\r\n  to   { opacity: 1; transform: scale(1) translateY(0); }\r\n}\r\n\r\n.help-card-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n}\r\n\r\n.help-card-close:hover {\r\n  color: #fff;\r\n}\r\n\r\n.help-card-title {\r\n  margin: 0;\r\n  padding: 18px 20px 10px;\r\n  font-size: 1.5rem;\r\n  color: var(--jedi-green, #c4de1d);\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.help-card-body {\r\n  padding: 4px 20px 20px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.help-section {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.help-section-title {\r\n  margin: 0 0 4px;\r\n  font-size: 1.3rem;\r\n  color: #fff;\r\n}\r\n\r\n.help-section-text {\r\n  margin: 0 0 6px;\r\n  font-size: 1.25rem;\r\n  line-height: 1.45;\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n.help-tts-link {\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--jedi-green, #c4de1d);\r\n  font-size: 1.2rem;\r\n  line-height: 1.45;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.help-tts-link:hover {\r\n  color: #e2f06a;\r\n}\r\n\r\n.help-tts-overlay {\r\n  z-index: 10011;\r\n}\r\n\r\n.help-tts-card {\r\n  width: min(960px, 96vw);\r\n  height: min(90vh, 90dvh);\r\n  max-height: min(90vh, 90dvh);\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.help-tts-iframe {\r\n  flex: 1;\r\n  width: 100%;\r\n  min-height: 0;\r\n  border: none;\r\n}\r\n\r\n.help-tts-footer {\r\n  padding: 16px 20px 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  background: rgba(10, 10, 30, 0.98);\r\n}\r\n\r\n.help-tts-back-button {\r\n  width: 100%;\r\n  padding: 12px 18px;\r\n  border: 1px solid rgba(196, 222, 29, 0.45);\r\n  border-radius: 12px;\r\n  background: linear-gradient(180deg, rgba(196, 222, 29, 0.22), rgba(196, 222, 29, 0.12));\r\n  color: #fff;\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.help-tts-back-button:hover {\r\n  background: linear-gradient(180deg, rgba(196, 222, 29, 0.3), rgba(196, 222, 29, 0.18));\r\n}\r\n\r\n.title {\r\n  font-size: clamp(1.35rem, 2vw + 0.7rem, 2.5rem);\r\n  margin: 0;\r\n  line-height: 1.1;\r\n  text-align: center;\r\n  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.9);\r\n  color: var(--jedi-main-title);\r\n}\r\n\r\n.instructions {\r\n  font-size: clamp(0.85rem, 0.7vw + 0.75rem, 1.2rem);\r\n  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);\r\n  margin: 0;\r\n  text-align: center;\r\n  color: var(--jedi-main-title);\r\n  line-height: 1.25;\r\n  max-width: min(90%, 720px);\r\n}\r\n\r\n.characters-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: clamp(8px, 2vw, 20px);\r\n  margin-bottom: 0;\r\n  width: min(100%, 820px);\r\n  max-width: 820px;\r\n}\r\n\r\n.character-item {\r\n  width: clamp(70px, 11vw, 100px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  border-radius: 10px;\r\n  padding: clamp(6px, 1vh, 10px) clamp(5px, 0.8vw, 10px);\r\n  min-height: clamp(90px, 14vw, 118px);\r\n  cursor: grab;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  touch-action: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.character-item:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.character-item.selected {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.character-item.dragging {\r\n  opacity: 0.3;\r\n  transform: scale(0.95);\r\n  pointer-events: none;\r\n}\r\n\r\n.character-item:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.character-image {\r\n  width: clamp(50px, 8vw, 80px);\r\n  height: clamp(50px, 8vw, 80px);\r\n  object-fit: contain;\r\n  margin-bottom: clamp(6px, 1vh, 10px);\r\n}\r\n\r\n.character-name {\r\n  font-size: clamp(0.72rem, 0.45vw + 0.65rem, 0.9rem);\r\n  text-align: center;\r\n  color: var(--jedi-main-title);\r\n  line-height: 1.15;\r\n}\r\n\r\n.userInfo-container {\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: center;\r\n  gap: clamp(10px, 1.5vw, 16px);\r\n  width: min(100%, 980px);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.board-drop-area {\r\n  width: auto;\r\n  max-width: none;\r\n  flex: 1 1 420px;\r\n  min-height: clamp(88px, 14vh, 140px);\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  border: 2px dashed rgba(255, 255, 255, 0.3);\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  padding: clamp(10px, 1.8vh, 20px);\r\n  margin-bottom: 0;\r\n  transition: background-color 0.3s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.board-drop-area:hover {\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.board-drop-area.touch-drag-active {\r\n  background-color: rgba(76, 175, 80, 0.2);\r\n  border-color: rgba(76, 175, 80, 0.6);\r\n  box-shadow: 0 0 20px rgba(76, 175, 80, 0.3);\r\n}\r\n\r\n.selected-characters {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  max-height: min(24vh, 220px);\r\n  overflow-y: auto;\r\n  padding-right: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.board-drop-area p {\r\n  margin: 0 0 8px;\r\n  font-size: clamp(0.82rem, 0.35vw + 0.72rem, 1rem);\r\n  text-align: center;\r\n}\r\n\r\n.userInfo-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.userInfo-item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.autoavaliacao, .userInfo {\r\n  padding: 12px 16px;\r\n  background-color: rgba(0, 0, 0, 0.25);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 10px;\r\n\r\n  position: relative !important;\r\n  height: max-content !important;\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.userInfo {\r\n  flex: 0 1 280px;\r\n  width: min(100%, 300px);\r\n  max-width: 320px;\r\n  max-height: fit-content !important;\r\n  align-self: stretch;\r\n}\r\n\r\n.autoavaliacao {\r\n  width: min(100%, 980px);\r\n}\r\n\r\n.autoavaliacao-title, .userInfo-title {\r\n  margin: 0 0 10px;\r\n  font-size: clamp(0.85rem, 0.35vw + 0.78rem, 0.95rem);\r\n  color: var(--jedi-main-title);\r\n  text-align: center;\r\n}\r\n\r\n.autoavaliacao-options {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n.autoavaliacao-option {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: clamp(5px, 0.7vh, 6px) clamp(8px, 1vw, 10px);\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n  color: #ffffff;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  font-size: clamp(0.78rem, 0.3vw + 0.72rem, 0.9rem);\r\n}\r\n\r\n.autoavaliacao-option.selected {\r\n  border-color: rgba(255, 255, 255, 0.45);\r\n  background: rgba(76, 175, 80, 0.2);\r\n}\r\n\r\n.autoavaliacao-option input[type=\"radio\"] {\r\n  accent-color: #4CAF50;\r\n}\r\n\r\n.selected-character {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  border-radius: 8px;\r\n  gap: clamp(8px, 1vw, 12px);\r\n  padding: clamp(8px, 1.2vh, 10px);\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n.selected-character-image {\r\n  width: clamp(35px, 6vw, 50px);\r\n  height: clamp(35px, 6vw, 50px);\r\n  object-fit: contain;\r\n  margin-right: 0;\r\n}\r\n\r\n.selected-character-info {\r\n  flex: 1;\r\n}\r\n\r\n.selected-character-name {\r\n  font-size: clamp(0.9rem, 0.5vw + 0.8rem, 1.1rem);\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.player-number {\r\n  font-size: clamp(0.75rem, 0.35vw + 0.68rem, 0.9rem);\r\n  color: #FFEB3B;\r\n}\r\n\r\n.remove-character {\r\n  background-color: rgba(255, 0, 0, 0.3);\r\n  border: none;\r\n  color: white;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.remove-character:hover {\r\n  background-color: rgba(255, 0, 0, 0.5);\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: min(100%, 980px);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.preferences-trigger {\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: calc(10px + env(safe-area-inset-bottom));\r\n  z-index: 10005;\r\n  background: var(--jedi-pink);\r\n  border: none;\r\n  border-radius: 999px;\r\n  color: #fff;\r\n  padding: 5px 15px;\r\n  font-weight: bold;\r\n  font-size: 0.8rem;\r\n  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);\r\n  cursor: pointer;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  transition: transform 0.2s ease, opacity 0.2s ease;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n}\r\n\r\n.preferences-trigger:hover {\r\n  transform: translate(-50%, -2px);\r\n}\r\n\r\n.bottom-sheet {\r\n  position: fixed;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  max-height: 90vh;\r\n  max-height: 90dvh;\r\n  transform: translateY(100%);\r\n  display: flex;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n  transition: transform 0.35s cubic-bezier(0.2, 1, 0.3, 1);\r\n  z-index: 10004;\r\n}\r\n\r\n.bottom-sheet--open {\r\n  transform: translateY(0);\r\n  pointer-events: auto;\r\n}\r\n\r\n.bottom-sheet__overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n.bottom-sheet__panel {\r\n  position: relative;\r\n  width: min(960px, 100%);\r\n  padding: 0 20px calc(30px + env(safe-area-inset-bottom));\r\n  pointer-events: auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.bottom-sheet__handle {\r\n  background: #ED62FF;\r\n  border-radius: 24px 24px 0 0;\r\n  padding: 12px 16px;\r\n  color: #fff;\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  cursor: grab;\r\n  font-weight: bold;\r\n  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.bottom-sheet__handle:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.bottom-sheet__chevron {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.game-preferences-panel {\r\n  width: 100%;\r\n  max-height: calc(90vh - 72px);\r\n  max-height: calc(90dvh - 72px);\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  border-radius: 18px;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  color: #fff;\r\n}\r\n\r\n.game-preferences-panel h3 {\r\n  margin: 0;\r\n  font-size: 1.4rem;\r\n  color: var(--jedi-main-title);\r\n  text-align: center;\r\n}\r\n\r\n.preference-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.preference-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.95rem;\r\n  color: #fefefe;\r\n}\r\n\r\n.preference-helper {\r\n  font-size: 0.8rem;\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.game-preferences-panel input[type=\"range\"] {\r\n  width: 100%;\r\n}\r\n\r\n.game-preferences-panel select {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  background: rgba(0, 0, 0, 0.4);\r\n  color: #fff;\r\n}\r\n\r\n.start-game-button {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 30px;\r\n  width: min(100%, 560px);\r\n  min-height: clamp(40px, 6vh, 52px);\r\n  padding: clamp(10px, 1.4vh, 12px) clamp(20px, 3vw, 30px);\r\n  font-size: clamp(0.95rem, 0.6vw + 0.85rem, 1.2rem);\r\n  font-weight: bold;\r\n  text-shadow: 3px 3px 7px rgba(0, 0, 0, 0.9);\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, transform 0.2s;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  line-height: 1.15;\r\n}\r\n\r\n.start-game-button:hover:not(:disabled) {\r\n  background-color: #45a049;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.start-game-button:disabled {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Estilos para o feedback visual de arrastar no touch */\r\n.touch-drag-image {\r\n  pointer-events: none;\r\n  z-index: 10000;\r\n}\r\n\r\n.dragging-preview {\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  border: 2px solid var(--jedi-green);\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\r\n  transform: rotate(5deg);\r\n}\r\n\r\n/* Melhorias para toque */\r\n.character-item {\r\n  touch-action: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -webkit-touch-callout: none;\r\n}\r\n\r\n.board-drop-area {\r\n  touch-action: none;\r\n}\r\n\r\n.sprite-loading-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n}\r\n\r\n.sprite-loading-card {\r\n  background: rgba(0, 0, 0, 0.85);\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  width: min(360px, 90vw);\r\n  text-align: center;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.sprite-loading-progress {\r\n  width: 100%;\r\n  height: 12px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.sprite-loading-progress-bar {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #4CAF50, #8BC34A);\r\n  transition: width 0.2s ease;\r\n}\r\n\r\n.sprite-loading-percentage {\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n  color: #ffffff;\r\n}\r\n\r\n.sprite-loading-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #ffffff;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.sprite-loading-list li {\r\n  padding: 4px 0;\r\n}\r\n\r\n.sprite-loading-error {\r\n  color: #ff6b6b;\r\n  font-weight: bold;\r\n}\r\n\r\n.sprite-loading-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.sprite-loading-close {\r\n  margin-top: 16px;\r\n  padding: 8px 16px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: #ffffff22;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n}\r\n\r\n.sprite-loading-close:hover {\r\n  background: #ffffff33;\r\n}\r\n\r\n/* Media queries para diferentes tamanhos de tela */\r\n@media (max-width: 480px) {\r\n  .character-selection-container {\r\n    padding: 5px;\r\n  }\r\n\r\n  .character-selection-content {\r\n    gap: 8px;\r\n    padding-bottom: calc(82px + env(safe-area-inset-bottom));\r\n  }\r\n\r\n  .character-selection-main {\r\n    padding: 0 2px 6px;\r\n  }\r\n\r\n  .game-preferences-panel {\r\n    padding: 15px;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .logo-jedi {\r\n    margin: 5px 0 !important;\r\n    padding: 5px !important;\r\n  }\r\n  \r\n  .logo-jedi img {\r\n    width: 40% !important;\r\n  }\r\n  \r\n  .title {\r\n    font-size: 1.4rem !important;\r\n    margin: 5px 0 !important;\r\n  }\r\n  \r\n  .instructions {\r\n    font-size: 0.85rem !important;\r\n    margin: 5px 0 10px 0 !important;\r\n    padding: 0 15px !important;\r\n  }\r\n  \r\n  .characters-container {\r\n    gap: 8px !important;\r\n    max-width: 100% !important;\r\n  }\r\n  \r\n  .character-item {\r\n    width: 70px !important;\r\n    padding: 8px 5px !important;\r\n    min-height: 90px !important;\r\n  }\r\n  \r\n  .character-image {\r\n    width: 50px !important;\r\n    height: 50px !important;\r\n  }\r\n  \r\n  .character-name {\r\n    font-size: 0.7rem !important;\r\n  }\r\n  \r\n  .userInfo-container {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .board-drop-area {\r\n    width: 100% !important;\r\n    min-height: 88px !important;\r\n    padding: 5px 10px !important;\r\n    flex-basis: auto !important;\r\n  }\r\n\r\n  .autoavaliacao,\r\n  .userInfo {\r\n    width: 100% !important;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .userInfo {\r\n    max-width: none !important;\r\n  }\r\n\r\n  .autoavaliacao-options {\r\n    gap: 6px;\r\n  }\r\n\r\n  .autoavaliacao-option {\r\n    font-size: 0.8rem;\r\n    padding: 5px 8px;\r\n  }\r\n\r\n  .game-preferences-panel {\r\n    width: 96%;\r\n  }\r\n  \r\n  .board-drop-area p {\r\n    font-size: 0.85rem !important;\r\n    margin: 0 0 3px 0 !important;\r\n  }\r\n  \r\n  .selected-character {\r\n    padding: 8px !important;\r\n  }\r\n  \r\n  .selected-character-image {\r\n    width: 35px !important;\r\n    height: 35px !important;\r\n  }\r\n  \r\n  .selected-character-name {\r\n    font-size: 0.9rem !important;\r\n  }\r\n  \r\n  .player-number {\r\n    font-size: 0.75rem !important;\r\n  }\r\n  \r\n  .remove-character {\r\n    width: 25px !important;\r\n    height: 25px !important;\r\n    font-size: 0.9rem !important;\r\n  }\r\n  \r\n  .start-game-button {\r\n    width: 100%;\r\n    padding: 10px 20px !important;\r\n    font-size: 0.95rem !important;\r\n    min-height: 40px !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 481px) and (max-width: 768px) {\r\n  .character-selection-container {\r\n    padding: 8px;\r\n  }\r\n  \r\n  .logo-jedi {\r\n    margin: 8px 0 !important;\r\n  }\r\n  \r\n  .logo-jedi img {\r\n    width: 45% !important;\r\n  }\r\n  \r\n  .title {\r\n    font-size: 1.6rem;\r\n    margin: 8px 0;\r\n  }\r\n  \r\n  .instructions {\r\n    font-size: 0.9rem;\r\n    padding: 0 15px;\r\n    text-align: center;\r\n    margin: 8px 0 15px 0;\r\n  }\r\n  \r\n  .characters-container {\r\n    gap: 12px;\r\n    padding: 0 10px;\r\n  }\r\n  \r\n  .character-item {\r\n    width: 80px;\r\n    padding: 12px 8px;\r\n    min-height: 100px;\r\n  }\r\n  \r\n  .character-image {\r\n    width: 60px;\r\n    height: 60px;\r\n  }\r\n  \r\n  .character-name {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .board-drop-area {\r\n    min-height: 100px;\r\n    padding: 3px 12px;\r\n  }\r\n\r\n  .autoavaliacao {\r\n    width: min(100%, 920px);\r\n  }\r\n  \r\n  .board-drop-area p {\r\n    font-size: 0.9rem;\r\n    margin: 0 0 5px 0;\r\n  }\r\n  \r\n  .selected-character {\r\n    padding: 12px;\r\n  }\r\n  \r\n  .selected-character-image {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n  \r\n  .selected-character-name {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .player-number {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .remove-character {\r\n    width: 35px;\r\n    height: 35px;\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .start-game-button {\r\n    padding: 12px 25px;\r\n    font-size: 1rem;\r\n    min-height: 45px;\r\n  }\r\n}\r\n\r\n/* Específico para dispositivos com toque */\r\n/* Ajustes para dispositivos muito pequenos */\r\n@media (max-height: 700px) {\r\n  .character-selection-container {\r\n    padding: 5px;\r\n  }\r\n\r\n  .character-selection-content {\r\n    gap: 6px;\r\n    padding-bottom: calc(74px + env(safe-area-inset-bottom));\r\n  }\r\n\r\n  .character-selection-main {\r\n    gap: 8px;\r\n  }\r\n  \r\n  .logo-jedi {\r\n    margin: 2px 0 !important;\r\n  }\r\n\r\n  .logo-jedi img {\r\n    width: min(32%, 150px) !important;\r\n  }\r\n  \r\n  .title {\r\n    font-size: 1.2rem !important;\r\n    margin: 2px 0 !important;\r\n  }\r\n  \r\n  .instructions {\r\n    font-size: 0.8rem !important;\r\n    margin: 2px 0 8px 0 !important;\r\n  }\r\n  \r\n  .characters-container {\r\n    margin-bottom: 10px !important;\r\n  }\r\n\r\n  .character-item {\r\n    min-height: 84px !important;\r\n    padding: 6px 5px !important;\r\n  }\r\n\r\n  .character-image {\r\n    width: 46px !important;\r\n    height: 46px !important;\r\n    margin-bottom: 4px !important;\r\n  }\r\n  \r\n  .board-drop-area {\r\n    min-height: 60px !important;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .selected-characters {\r\n    max-height: min(18vh, 160px);\r\n  }\r\n\r\n  .autoavaliacao,\r\n  .userInfo {\r\n    padding: 8px 10px !important;\r\n  }\r\n\r\n  .autoavaliacao-title,\r\n  .userInfo-title {\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  .autoavaliacao-option {\r\n    padding: 4px 8px;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .start-game-button {\r\n    min-height: 38px !important;\r\n    font-size: 0.9rem !important;\r\n    padding: 8px 16px !important;\r\n  }\r\n\r\n  .preferences-trigger {\r\n    font-size: 0.72rem;\r\n    padding: 5px 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) and (max-height: 700px) {\r\n  .logo-jedi img {\r\n    width: min(34%, 128px) !important;\r\n  }\r\n\r\n  .userInfo-container {\r\n    gap: 8px;\r\n  }\r\n\r\n  .board-drop-area p {\r\n    font-size: 0.8rem !important;\r\n  }\r\n\r\n  .selected-character {\r\n    padding: 6px !important;\r\n  }\r\n\r\n  .selected-character-name {\r\n    font-size: 0.82rem !important;\r\n  }\r\n\r\n  .player-number {\r\n    font-size: 0.7rem !important;\r\n  }\r\n}\r\n\r\n@media (pointer: coarse) {\r\n  .character-item {\r\n    margin: 0;\r\n  }\r\n  \r\n  .character-item:hover {\r\n    /* Remover hover em dispositivos de toque */\r\n    transform: none;\r\n    box-shadow: none;\r\n  }\r\n  \r\n  .character-item:active {\r\n    transform: scale(0.95);\r\n    box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);\r\n  }\r\n  \r\n  .board-drop-area:hover {\r\n    /* Remover hover em dispositivos de toque */\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n  }\r\n}\r\n\r\n/* Estilos para versão do jogo */\r\n.game-version {\r\n  cursor: pointer;\r\n  bottom: calc(10px + env(safe-area-inset-bottom)) !important;\r\n  right: clamp(6px, 2vw, 10px) !important;\r\n  font-size: clamp(0.7rem, 1.5vw, 0.8rem) !important;\r\n}\r\n\r\n.version-info {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.build-info {\r\n  display: none;\r\n  margin: 4px 0 4px 0;\r\n  padding: 0;\r\n  font-size: 1.2rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.game-version:hover .build-info {\r\n  display: block;\r\n} \r\n.game-version:hover .version-info {\r\n  display: none;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
